import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'linkify' })
export class LinkifyPipe implements PipeTransform {

  constructor(private _domSanitizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    return this._domSanitizer.bypassSecurityTrustHtml(this.stylize(value));
  }

  private stylize(text: string): string {
    var palavraAnterior: string = '';
    let stylizedText: string = '';
    if (text && text.length > 0) {
      for (let line of text.split("\n")) {
        for (let t of line.split(" ")) {
          if (t.startsWith("http") && t.length>7) {
            stylizedText = stylizedText.substring(0, stylizedText.length - palavraAnterior.length - 1);
            stylizedText += `<a href="${t}">${palavraAnterior}</a> `;
          }
          else if (t.startsWith("javascript") && t.length>7) {
            stylizedText = stylizedText.substring(0, stylizedText.length - palavraAnterior.length - 1);
            stylizedText += `<a href="javascript:void(0);" onclick="${t}; return false;">${palavraAnterior}</a> `;
          }
          else
            stylizedText += t + " ";

            palavraAnterior = t;
        }
        stylizedText += '<br>';
      }
      return stylizedText;
    }
    else return text;
  }
}